import type { IFilter } from "../../../../types/models/filter.models.types";
import type { IPagination } from "../../../../types/models/pagination.models.types";
import type { ISocial } from "../../../../types/models/social.models.types";
import { useGetHttp } from "../../http.hook";


export interface IFavoriteSocialMinimal {
  social: ISocial;
  createdAt: Date | null;
  createdBy: {
    accountType: string;
    name: string;
    email: string;
    id: string;
  } | null;
}


export interface IFavoriteSocial {
  createdAt: Date;
  socials: IFavoriteSocialMinimal[];
  name: string;
  id: string;
  filter: IFilter;
  description: string;
}

interface IResponse {
  favouriteSocial: IFavoriteSocial;
  pagination: IPagination;
}

export function useGetFavoritesByIdAdminHttp() {
  return useGetHttp<IResponse>({
    path: "/admin/favourite-socials/:id",
  });
}
